"use client";
import React, { useState } from "react";
import { usePostHog } from "posthog-js/react";

export function cookieConsentGiven() {
  if (!localStorage.getItem("cookie_consent")) {
    return "undecided";
  }
  return localStorage.getItem("cookie_consent");
}

export default function CookieBanner() {
  const [consentGiven, setConsentGiven] = useState("");
  const posthog = usePostHog();

  React.useEffect(() => {
    // We want this to only run once the client loads
    // or else it causes a hydration error
    setConsentGiven(cookieConsentGiven());
  }, []);

  React.useEffect(() => {
    if (consentGiven !== "") {
      posthog.set_config({ persistence: consentGiven === "yes" ? "localStorage+cookie" : "memory" });
    }
  }, [consentGiven]);

  const handleAcceptCookies = () => {
    localStorage.setItem("cookie_consent", "yes");
    setConsentGiven("yes");
  };

  const handleDeclineCookies = () => {
    localStorage.setItem("cookie_consent", "no");
    setConsentGiven("no");
  };
  if (consentGiven !== "undecided") return null;
  return (
    <div className="z-50 fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-4 md:p-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="text-blue-600 flex-shrink-0">
            <CookieIcon />
          </div>
          <div>
            <h3 className="text-lg font-medium text-gray-900">Cookie Notice</h3>
            <p className="text-gray-600 text-sm md:text-base max-w-2xl">
              We use cookies to enhance your browsing experience, analyze site traffic, and personalize
              content.
              By clicking "Accept cookies", you consent to our use of cookies.
            </p>
          </div>
        </div>

        <div className="flex gap-3 mt-4 md:mt-0">
          <button
            onClick={handleDeclineCookies}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
          >
            Decline cookies
          </button>
          <button
            onClick={handleAcceptCookies}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
          >
            Accept cookies
          </button>
        </div>
      </div>
    </div>
  );
}

function CookieIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" />
      <circle cx="7" cy="7" r="1" />
      <circle cx="17" cy="8" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="16" cy="15" r="1" />
      <circle cx="8" cy="16" r="1" />
    </svg>
  );
}